import React from 'react'
import { defineMessage } from 'react-intl'

import { CustomerSubpopulations, GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

import { DefaultCustomerRedirectionHeaderText } from './default'

export const turner: GetCustomerCopyFunc = () => {
  const subpopulations: CustomerSubpopulations = {
    header: <DefaultCustomerRedirectionHeaderText customerName='Turner' />,
    options: [
      {
        label: defineMessage({
          defaultMessage: 'Staff Employee',
          description: 'Turner Staff Employee label',
        }),
        description: defineMessage({
          defaultMessage: 'I am a Staff employee or eligible dependent of Turner Construction.',
          description: 'Turner staff employee or eligible dependent description',
        }),
      },
      {
        label: defineMessage({
          defaultMessage: 'Non-Union Trade Employee',
          description: 'Turner Non-Union Trade Employee label',
        }),
        description: defineMessage({
          defaultMessage: 'I am a Non-Union Trade employee or eligible dependent of Turner Construction.',
          description: 'Turner non-union trade employee or eligible dependent description',
        }),
      },
    ],
  }
  return {
    subpopulations,
  }
}
